import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { addBuyersValidation } from "../../utils/validation";
import * as api from "../../redux/api";
import { toast } from "react-toastify";
import { isYupError, parseYupError } from "../../utils/Yup";
const initialState = {
  walletAddress: "",
  fractionToBuy: null,
  totalPrice: null,
  type: "Offline",
  paymentId: ""
};

const AddBuyerModal = ({ handleClose, open, buyerId }) => {
  const [type, setType] = useState("");
  const [selectVal, setSelectVal] = useState("Offline");
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState(initialState);
  const [fractionPrice, setFractionPrice] = useState(null);
  const [formError, setFormError] = useState(initialState);
  const [calculateGst, setCalculateGst] = useState(0);
  const [totalPriceOfFraction, setTotalPriceOfFraction] = useState(0);
  const [totalPriceInclusiveGst, setTotalPriceInclusiveGst] = useState(0);
  const handleCloseModal = () => {
    handleClose();
    setForm(initialState);
    setFormError({});
    setCalculateGst(0);
    setTotalPriceInclusiveGst(0);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
    setFormError({
      ...formError,
      [name]: ""
    });
  };
  const getSingleFaction = async () => {
    setIsLoading(true);
    const res = await api.getSingleFactionAmount();
    const { status, data } = res;

    if (status >= 200 && status < 300) {
      setIsLoading(false);
      setFractionPrice(data);
    } else {
      setIsLoading(false);
      toast.error(data.message);
    }
  };
  useEffect(() => {
    getSingleFaction();
  }, []);

  const handleSubmit = async () => {
    setIsLoading(true);
    if (selectVal === "Other" && type === "") {
      setFormError({
        ...formError,
        otherTypeDescription: "Please select payment mode"
      });
      setIsLoading(false);
      return false;
    }
    try {
      setFormError({});
      await addBuyersValidation.validate(form, {
        abortEarly: false
      });
      const payload = {
        ...form,
        userId: buyerId,
        gstAmount: parseFloat(calculateGst.toFixed(2)),
        youWillPay: parseFloat(totalPriceInclusiveGst.toFixed(2))
      };
      const res = await api.addtoBuyer({
        ...payload,
        ...(selectVal === "Other" ? { otherTypeDescription: type } : {})
      });
      if (res.status === 200 || res.status === 201) {
        setIsLoading(false);
        toast.success("Created Successfully");
        handleCloseModal();
        setCalculateGst(0);
        setTotalPriceInclusiveGst(0);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      if (isYupError(error)) {
        setFormError(parseYupError(error));
        setIsLoading(false);
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
        setIsLoading(false);
      }

      setIsLoading(false);
    }
  };
  const handleSelect = (e) => {
    const { value, name } = e.target;
    setSelectVal(e.target.value);
    setForm({
      ...form,
      [name]: value
    });
  };
  const fractionCalculatedPrise =
    fractionPrice?.currentNodeFractionPrice +
    fractionPrice?.index *
      Number(fractionPrice?.fractionPriceIncrementConstant);
  useEffect(() => {
    if (form?.fractionToBuy && fractionCalculatedPrise) {
      const gstForPrice =
        fractionCalculatedPrise * Number(form.fractionToBuy) * (18 / 100);
      setCalculateGst(gstForPrice);
      const totalPriceInclusiveGST =
        fractionCalculatedPrise * Number(form.fractionToBuy) + gstForPrice;
      setTotalPriceInclusiveGst(totalPriceInclusiveGST);
    }
  }, [totalPriceOfFraction, form?.fractionToBuy, fractionCalculatedPrise]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseModal}
        scroll={"paper"}
        fullWidth={true}
        maxWidth={"sm"}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {" "}
          <h4 className=" text-center">Purchase</h4>
        </DialogTitle>
        <DialogContent dividers={"paper"}>
          <div>
            <div className="max-w-4xl ">
              <div className="w-full grid grid-cols-2 gap-6 mt-4">
                <div className="input_field col-span-2">
                  <input
                    type="text"
                    placeholder="Enter wallet address"
                    name="walletAddress"
                    onChange={handleChange}
                    value={form.walletAddress}
                  />
                  {formError.walletAddress && (
                    <div className="form-eror">{formError.walletAddress}</div>
                  )}
                </div>
                <div className="input_field">
                  <input
                    type="number"
                    placeholder="Enter Fraction for buy"
                    name="fractionToBuy"
                    min={0}
                    onChange={(e) => {
                      const value = Number(e.target.value);
                      if (value < 0) return;
                      handleChange(e);
                      setForm((prev) => ({
                        ...prev,
                        totalPrice: fractionCalculatedPrise * value
                      }));
                      setTotalPriceOfFraction(fractionCalculatedPrise * value);
                    }}
                    onWheel={(e) => e.target.blur()}
                  />
                  {formError.fractionToBuy && (
                    <div className="form-eror">{formError.fractionToBuy}</div>
                  )}
                </div>
                <div className="input_field">
                  <input
                    type="number"
                    placeholder="GST (18%)"
                    name="gstAmount"
                    value={form?.fractionToBuy > 0 ? calculateGst : ""}
                    disabled
                  />
                  {/* {formError.totalPrice && (
                      <div className="form-eror">{formError.totalPrice}</div>
                    )} */}
                </div>
                <div className="input_field">
                  <input
                    type="number"
                    placeholder="Total Price of fraction"
                    name="totalPrice"
                    value={
                      form.fractionToBuy === null || form.fractionToBuy === ""
                        ? ""
                        : fractionPrice?.currentNodeFractionPrice +
                          fractionPrice?.index *
                            Number(
                              fractionPrice?.fractionPriceIncrementConstant
                            ) *
                            form.fractionToBuy
                    }
                    disabled
                  />
                  {/* {formError.totalPrice && (
                      <div className="form-eror">{formError.totalPrice}</div>
                    )} */}
                </div>
                <div className="input_field">
                  <input
                    type="number"
                    placeholder="Total Price You Will Pay"
                    name="youWillPay"
                    value={
                      form?.fractionToBuy > 0 ? totalPriceInclusiveGst : ""
                    }
                    disabled
                  />
                  {/* {formError.totalPrice && (
                      <div className="form-eror">{formError.totalPrice}</div>
                    )} */}
                </div>
                <div className="input_field">
                  <input
                    type="text"
                    placeholder="Enter payment Id"
                    name="paymentId"
                    value={form.paymentId}
                    onChange={handleChange}
                  />
                </div>
                <div className="input_field">
                  <select
                    id="type"
                    name="type"
                    className="bg-white border border-gray-300 text-[#000000] text-sm rounded-lg block w-full p-2.5"
                    placeholder="Select Payment Mode"
                    onChange={handleSelect}
                  >
                    <option value="Offline">Cash</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                {selectVal === "Other" && (
                  <div className="input_field">
                    <input
                      type="text"
                      placeholder="Payment Mode"
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    />
                    {formError.otherTypeDescription && (
                      <div className="form-eror">
                        {formError.otherTypeDescription}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            type="button"
            onClick={handleCloseModal}
            className={`btn btn-danger `}
          >
            Close
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={isLoading}
            className={`btn btn-primary ${
              isLoading
                ? "bg-red-500 border-red-500 opacity-50 disabled:pointer-events-none"
                : undefined
            }`}
          >
            {isLoading ? "Loading" : "Submit"}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddBuyerModal;
